import PropTypes from "prop-types";
import { memo, useMemo } from "react";

// material-ui
import { Box, Chip, Drawer, Stack, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import { useDispatch, useSelector } from "store";
import { drawerWidth } from "store/constant";
import { openDrawer } from "store/slices/menu";
import LogoSection from "../LogoSection";
import MenuCard from "./MenuCard";
import MenuList from "./MenuList";
// import Chip from 'ui-component/extended/Chip';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ window, negocio }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);

  const logo = useMemo(
    () => (
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Box sx={{ display: "flex", p: 2, mx: "auto" }}>
          <LogoSection />
        </Box>
      </Box>
    ),
    []
  );

  const drawer = useMemo(
    () => (
      <PerfectScrollbar
        component="div"
        style={{
          height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 95px)",
          paddingLeft: "16px",
          paddingRight: "16px",
        }}>
        <Box sx={{ py: 1 }}>
          <MenuList negocio={negocio} />
          {negocio.rol === "ADMIN" && <MenuCard />}
          <Stack direction="row" justifyContent="center" sx={{ mb: 2, mt: 2 }}>
            <Chip
              label={process.env.REACT_APP_VERSION}
              disabled
              chipcolor="secondary"
              size="small"
              sx={{
                cursor: "pointer",
                borderRadius: "16px",
                bgcolor: theme.palette.grey[100],
                color: theme.palette.grey[600],
                fontSize: "0.75rem",
                height: "24px",
              }}
            />
          </Stack>
        </Box>
      </PerfectScrollbar>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [matchUpMd, negocio]
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : "auto" }} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={() => dispatch(openDrawer(!drawerOpen))}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: "none",
            boxShadow: theme.palette.mode === "dark" ? "none" : "0 2px 8px rgba(0,0,0,0.1)",
            backdropFilter: "blur(8px)",
            [theme.breakpoints.up("md")]: {
              top: "100px",
            },
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit">
        {drawerOpen && logo}
        {drawerOpen && drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  window: PropTypes.object,
};

export default memo(Sidebar);
